/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFriendEntryResponse } from './IFriendEntryResponse';
import {
    IFriendEntryResponseFromJSON,
    IFriendEntryResponseFromJSONTyped,
    IFriendEntryResponseToJSON,
    IFriendEntryResponseToJSONTyped,
} from './IFriendEntryResponse';
import type { IncomingFriendRequest } from './IncomingFriendRequest';
import {
    IncomingFriendRequestFromJSON,
    IncomingFriendRequestFromJSONTyped,
    IncomingFriendRequestToJSON,
    IncomingFriendRequestToJSONTyped,
} from './IncomingFriendRequest';

/**
 * 
 * @export
 * @interface GetPendingFriendRequestsResponse
 */
export interface GetPendingFriendRequestsResponse {
    /**
     * Friend requests you've received
     * @type {Array<IncomingFriendRequest>}
     * @memberof GetPendingFriendRequestsResponse
     */
    incoming: Array<IncomingFriendRequest>;
    /**
     * Friend requests you've sent that are still pending
     * @type {Array<IFriendEntryResponse>}
     * @memberof GetPendingFriendRequestsResponse
     */
    outgoing: Array<IFriendEntryResponse>;
}

/**
 * Check if a given object implements the GetPendingFriendRequestsResponse interface.
 */
export function instanceOfGetPendingFriendRequestsResponse(value: object): value is GetPendingFriendRequestsResponse {
    if (!('incoming' in value) || value['incoming'] === undefined) return false;
    if (!('outgoing' in value) || value['outgoing'] === undefined) return false;
    return true;
}

export function GetPendingFriendRequestsResponseFromJSON(json: any): GetPendingFriendRequestsResponse {
    return GetPendingFriendRequestsResponseFromJSONTyped(json, false);
}

export function GetPendingFriendRequestsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPendingFriendRequestsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'incoming': ((json['incoming'] as Array<any>).map(IncomingFriendRequestFromJSON)),
        'outgoing': ((json['outgoing'] as Array<any>).map(IFriendEntryResponseFromJSON)),
    };
}

export function GetPendingFriendRequestsResponseToJSON(json: any): GetPendingFriendRequestsResponse {
    return GetPendingFriendRequestsResponseToJSONTyped(json, false);
}

export function GetPendingFriendRequestsResponseToJSONTyped(value?: GetPendingFriendRequestsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'incoming': ((value['incoming'] as Array<any>).map(IncomingFriendRequestToJSON)),
        'outgoing': ((value['outgoing'] as Array<any>).map(IFriendEntryResponseToJSON)),
    };
}

